import { render, staticRenderFns } from "./EditStaticFileDialog.vue?vue&type=template&id=515e46c7&"
import script from "./EditStaticFileDialog.vue?vue&type=script&lang=js&"
export * from "./EditStaticFileDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports